$(document).ready(function () {
  // var totalQty = 0;
  var totalQty = $(".swatch__input:checked").data("qty");
  // $('.swatch__input:checked').each(function() {
  //   totalQty += $(this).data('qty');
  // });
  if (totalQty < 0) {
    $(".instock_p0, .in_stock_img0").hide();
    $(".out_of_stock_p0, .out_of_stock_img0").show();
    $(".out_of_stock_p0 .variant_date").text(date);
    $(".product__block.shipping_date").hide();
  } else {
    $(".out_of_stock_p0, .out_of_stock_img0").hide();
    $(".instock_p0, .in_stock_img0").show();
    $(".product__block.shipping_date").show();
  }
});

$(document).ready(function () {
  // var totalQtyN = 0;
  var totalQtyN = $(".swatch__input:checked").data("qty");
  if (totalQtyN > 10) {
    $(".variant__countdown--in").show();
    $(".variant__countdown--low").hide();
    $(".variant__countdown--out").hide();
    $(".variant__countdown--unavailable").hide();
    $(".product__block.shipping_date").show();
  } else if (totalQtyN > 0) {
    $(".variant__countdown--in").hide();
    $(".variant__countdown--low").show();
    $(".variant__countdown--out").hide();
    $(".variant__countdown--unavailable").hide();
    $(".product__block.shipping_date").show();
  } else if (totalQtyN < 1) {
    $(".variant__countdown--in").hide();
    $(".variant__countdown--low").hide();
    $(".variant__countdown--out").hide();
    $(".variant__countdown--unavailable").show();
    $(".product__block.shipping_date").hide();
  }
  // });
});

$(document).ready(function () {
  var qty_product = $($(".swatch__input:checked")).data("qty");
  var date_product = $(".swatch__input:checked").data("date");
  // setTimeout(function(){
  if (qty_product < 1) {
    $("#reservation-date").val(date_product);
  } else {
    $("#reservation-date").val("");
  }
  // }, 1000);
});

$(".radio__input").on("change", function () {
  console.log("SWATHC INPUT CHANGE");
  var qty = $(this).data("qty");
  var date = $(this).data("date");
  setTimeout(function () {
    if (qty < 1) {
      // alert(qty);
      $(".instock_p0,.in_stock_img0").hide();
      $(".out_of_stock_p0, .out_of_stock_img0").show();
      $(".out_of_stock_p0 .variant_date").text(date);
      $("#reservation-date").val(date);
      $(".product__block.shipping_date").hide();
      console.log("Disable");
    } else {
      // alert(qty);
      console.log("Not Disable");
      $(".out_of_stock_p0, .out_of_stock_img0").hide();
      $(".instock_p0, .in_stock_img0").show();
      $(".product__block.shipping_date").show();
      $("#reservation-date").val("");
    }
    if (qty > 10) {
      $(".variant__countdown--in").show();
      $(".variant__countdown--low").hide();
      $(".variant__countdown--out").hide();
      $(".variant__countdown--unavailable").hide();
      $(".product__block.shipping_date").show();
    } else if (qty > 0) {
      $(".variant__countdown--in").hide();
      $(".variant__countdown--low").show();
      $(".variant__countdown--out").hide();
      $(".variant__countdown--unavailable").hide();
      $(".product__block.shipping_date").show();
    } else if (qty < 1) {
      $(".variant__countdown--in").hide();
      $(".variant__countdown--low").hide();
      $(".variant__countdown--out").hide();
      $(".variant__countdown--unavailable").show();
      $(".product__block.shipping_date").hide();
    }
  }, 500);
});
$(".swatch__input").on("change", function () {
  console.log("SWATHC INPUT CHANGE");
  var qty = $(this).data("qty");
  var date = $(this).data("date");
  setTimeout(function () {
    if (qty < 1) {
      // alert(qty);
      $(".instock_p0,.in_stock_img0").hide();
      $(".out_of_stock_p0, .out_of_stock_img0").show();
      $(".out_of_stock_p0 .variant_date").text(date);
      $("#reservation-date").val(date);
      $(".product__block.shipping_date").hide();
      console.log("Disable");
    } else {
      // alert(qty);
      console.log("Not Disable");
      $(".out_of_stock_p0, .out_of_stock_img0").hide();
      $(".instock_p0, .in_stock_img0").show();
      $(".product__block.shipping_date").show();
      $("#reservation-date").val("");
    }
    if (qty > 10) {
      $(".variant__countdown--in").show();
      $(".variant__countdown--low").hide();
      $(".variant__countdown--out").hide();
      $(".variant__countdown--unavailable").hide();
      $(".product__block.shipping_date").show();
    } else if (qty > 0) {
      $(".variant__countdown--in").hide();
      $(".variant__countdown--low").show();
      $(".variant__countdown--out").hide();
      $(".variant__countdown--unavailable").hide();
      $(".product__block.shipping_date").show();
    } else if (qty < 1) {
      $(".variant__countdown--in").hide();
      $(".variant__countdown--low").hide();
      $(".variant__countdown--out").hide();
      $(".variant__countdown--unavailable").show();
      $(".product__block.shipping_date").hide();
    }
  }, 500);
});

// document.addEventListener("DOMContentLoaded", function () {
//   var swatchInputs = document.querySelectorAll(".swatch__input:checked");
//   var totalQty =
//     swatchInputs.length > 0
//       ? parseInt(swatchInputs[0].getAttribute("data-qty"))
//       : 0;

//   if (totalQty < 0) {
//     document
//       .querySelectorAll(".instock_p0, .in_stock_img0")
//       .forEach((el) => (el.style.display = "none"));
//     document
//       .querySelectorAll(".out_of_stock_p0, .out_of_stock_img0")
//       .forEach((el) => (el.style.display = "block"));
//     document
//       .querySelectorAll(".out_of_stock_p0 .variant_date")
//       .forEach((el) => (el.textContent = date));
//     document
//       .querySelectorAll(".product__block.shipping_date")
//       .forEach((el) => (el.style.display = "none"));
//   } else {
//     document
//       .querySelectorAll(".out_of_stock_p0, .out_of_stock_img0")
//       .forEach((el) => (el.style.display = "none"));
//     document
//       .querySelectorAll(".instock_p0, .in_stock_img0")
//       .forEach((el) => (el.style.display = "block"));
//     document
//       .querySelectorAll(".product__block.shipping_date")
//       .forEach((el) => (el.style.display = "block"));
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var swatchInputsN = document.querySelectorAll(".swatch__input:checked");
//   var totalQtyN =
//     swatchInputsN.length > 0
//       ? parseInt(swatchInputsN[0].getAttribute("data-qty"))
//       : 0;

//   if (totalQtyN > 10) {
//     // similar DOM manipulations as above
//   } else if (totalQtyN > 0) {
//     // similar DOM manipulations as above
//   } else if (totalQtyN < 1) {
//     // similar DOM manipulations as above
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var swatchInputsProduct = document.querySelectorAll(".swatch__input:checked");
//   var qtyProduct =
//     swatchInputsProduct.length > 0
//       ? parseInt(swatchInputsProduct[0].getAttribute("data-qty"))
//       : 0;
//   var dateProduct =
//     swatchInputsProduct.length > 0
//       ? swatchInputsProduct[0].getAttribute("data-date")
//       : "";

//   if (qtyProduct < 1) {
//     document.getElementById("reservation-date").value = dateProduct;
//   } else {
//     document.getElementById("reservation-date").value = "";
//   }
// });

// document.querySelectorAll(".swatch__input").forEach((input) => {
//   input.addEventListener("change", function () {
//     var qty = parseInt(this.getAttribute("data-qty"));
//     var date = this.getAttribute("data-date");

//     setTimeout(function () {
//       // Similar DOM manipulations and condition checks as above
//     }, 500);
//   });
// });
